import { actions } from "./Reducer";
/**
 * Actions that fire saga watchers
 */

// singular
export const checkCustomerLimitsAction = (body) => ({
  type: actions.CHECK_CUSTOMER_LIMITS,
  payload: body
})


export const checkCustomerLimitsSuccessAction = (check) => ({
  type: actions.CHECK_CUSTOMER_LIMITS_SUCCCESS,
  payload: check
})